<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg button-text-color p-1 bg-tertiary"
      >
        <icon name="page_turners" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        Latest Page Turner
      </h3>
    </div>
    <a
      :href="`${pageTurnerDomain}/${selectedOffice.username}`"
      target="_blank"
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
    >
      View
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [ 'module' ],
  computed: {
    ...mapState(['selectedOffice']),
    pageTurnerDomain () {
      return process.env.VUE_APP_PAGE_TURNER_URL
    }
  }
}
</script>
